import { ColorIndicator } from "@/components/color-palette/ColorPalette";
import { NodeCurrentColor } from "@/components/doc/right-sidebar/node-viewer/NodeColorSelector";
import { ExpressionRealNodePreview } from "@/components/expression/preview/ExpressionNodePreview";
import { Icon } from "@/components/icons/Icon";
import { checkShouldRenderPreviewAsRealNode } from "@/components/suggestions/providers/preview";

import type { Suggestion } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  suggestion: Suggestion;
};

export function SuggestionIcon({ suggestion, doc }: Props) {
  if (checkShouldRenderPreviewAsRealNode(suggestion, doc)) {
    return (
      <ExpressionRealNodePreview renderContext="suggestion" suggestion={suggestion} doc={doc} />
    );
  }

  if (suggestion.type === "color") {
    return suggestion.target === "node" ? (
      <NodeCurrentColor color={suggestion.color} className="sm:w-7 sm:h-7" />
    ) : (
      <ColorIndicator color={suggestion.color} className="sm:w-7 sm:h-7" />
    );
  }

  if (suggestion.icon) {
    return <Icon name={suggestion.icon} className="sm:w-[28px] sm:h-[28px]" />;
  }

  if (suggestion.type !== "single") {
    return null;
  }

  return <div className="font-mono select-none font-normal">{suggestion.item.symbol}</div>;
}
